import { Container } from 'inversify';
import { INVERSIFY_TYPES } from '@edikk-edikk/ui';
import { Api } from '#src/react/api/Api';

const initApi = (diContainer: Container): void => {
  diContainer.bind<Api>(INVERSIFY_TYPES.api)
    .toDynamicValue(() => new Api(diContainer))
    .inSingletonScope();
};

export { initApi };
